import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketPill } from '@market/react';
import { getPhoneNumber } from 'utils/phoneNumber';
import MerchantContactInfoLine from './MerchantContactInfoLine';
import { FormattedMerchantLocation } from './view-models/FormattedMerchantLocation';

interface MerchantLocationProps {
  merchantLocationFormatted: FormattedMerchantLocation;
  shouldShowContactInfo: boolean;
  hasLoyalty?: boolean;
}

const MerchantLocation: React.FC<MerchantLocationProps> = ({
  merchantLocationFormatted,
  shouldShowContactInfo,
  hasLoyalty = false,
}) => {
  const { t } = useTranslation();
  const phoneNumber = getPhoneNumber(
    merchantLocationFormatted.phone?.number ?? '',
    merchantLocationFormatted.phone?.callingCode,
    merchantLocationFormatted.address?.countryCode
  );

  return (
    <div className="merchant-location-container">
      {(merchantLocationFormatted.name ||
        merchantLocationFormatted.address?.locality) && (
        <div className="flex items-center gap-2">
          <p className="medium-30 m-0" data-testid="city-element">
            {merchantLocationFormatted.name ??
              merchantLocationFormatted.address?.locality}
          </p>
          {hasLoyalty && (
            <MarketPill variant="emphasis" data-testid="loyalty-pill">
              {t('merchantPortal.merchantLocation.loyaltyPill')}
            </MarketPill>
          )}
        </div>
      )}
      <MerchantContactInfoLine
        text={
          merchantLocationFormatted?.formattedAddress ??
          t('merchantPortal.merchantLocation.noAddress')
        }
        testId="address-element"
      />
      <br />
      {shouldShowContactInfo && (
        <div>
          {phoneNumber && (
            <MerchantContactInfoLine
              text={`${t('common.tel')}:`}
              testId="phone-number"
              phoneNumber={phoneNumber}
            />
          )}
          {merchantLocationFormatted?.email && (
            <MerchantContactInfoLine
              text={`${t('common.email')}: ${merchantLocationFormatted?.email}`}
              testId="email-address"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MerchantLocation;
